import * as React from 'react';
import {
  AlignItems,
  BorderScale,
  BorderStyle,
  Box,
  BoxProps,
  Color,
  Display,
} from '@gousto-internal/citrus-react';

export enum PillVariant {
  Success = 'success',
  Default = 'default',
  RafPulse = 'raf-pulse',
}

const pillVariantStyles: Record<
  PillVariant,
  {
    bg: Color;
    borderColor?: Color;
    borderStyle?: BorderStyle;
    borderWidth?: BorderScale;
    color?: Color;
  }
> = {
  [PillVariant.Success]: {
    bg: Color.Success_50,
    borderColor: Color.Success_200,
    borderStyle: BorderStyle.Solid,
    borderWidth: 0.5,
  },
  [PillVariant.Default]: {
    bg: Color.White,
  },
  [PillVariant.RafPulse]: {
    bg: Color.ColdGrey_600,
    color: Color.White,
  },
};

type PillProps = {
  children: React.ReactNode;
  variant?: PillVariant;
} & Omit<BoxProps, 'children'>;

export function Pill(props: PillProps) {
  const { children, paddingH = [2], variant = PillVariant.Default, ...boxProps } = props;

  const variantStyles = pillVariantStyles[variant];

  return (
    <Box
      style={{ borderRadius: '50px' }}
      paddingV={2}
      paddingH={paddingH}
      display={Display.InlineBlock}
      alignItems={AlignItems.Center}
      {...variantStyles}
      {...boxProps}
    >
      {children}
    </Box>
  );
}
